module.exports = "/images/intercard.svg?ddea1887161e38593119bc20f4344a21";